<template>
	<div
		class="summary__contents"
		:class="`is-sectionTitle-${sectionTitleStyle}`"
	>
		<div class="summary__section">
			<p class="summary__sectionTitle">{{ $t("Deltas") }}</p>

			<div class="summary__grid">
				<div class="summary__item">
					<div class="summary__itemValue" v-html="deltaCfgSummaryContent"></div>
				</div>
			</div>
		</div>

		<template v-if="values.wind.cfgMode.isBandByBand">
			<div class="summary__section">
				<p class="summary__sectionTitle">{{ $t("Pressão") }}</p>

				<div class="summary__grid" v-for="char in ['w', 'l']" :key="char">
					<div class="summary__item" v-for="num in 3" :key="num">
						<div class="summary__itemLabel">
							{{ char.toUpperCase() }}{{ num }}
						</div>
						<div class="summary__itemValue">
							{{ values.wind.general.pressure[char][num - 1] }} kN/m2
						</div>
					</div>
				</div>
			</div>

			<div class="summary__section">
				<p class="summary__sectionTitle">{{ $t("Sucção") }}</p>

				<div class="summary__grid" v-for="char in ['w', 'l']" :key="char">
					<div class="summary__item" v-for="num in 3" :key="num">
						<div class="summary__itemLabel">
							{{ char.toUpperCase() }}{{ num }}
						</div>
						<div class="summary__itemValue">
							{{ values.wind.general.suction[char][num - 1] }} kN/m2
						</div>
					</div>
				</div>
			</div>

			<template v-if="values.wind.local.use">
				<div class="summary__section">
					<p class="summary__sectionTitle">{{ $("Pressão Vento Local") }}</p>

					<div class="summary__grid" v-for="char in ['w', 'l']" :key="char">
						<div class="summary__item" v-for="num in 3" :key="num">
							<div class="summary__itemLabel">
								{{ char.toUpperCase() }}{{ num }}
							</div>
							<div class="summary__itemValue">
								{{ values.wind.local.pressure[char][num - 1] }} kN/m2
							</div>
						</div>
					</div>
				</div>

				<div class="summary__section">
					<p class="summary__sectionTitle">{{ $t("Sucção Vento Local") }}</p>

					<div class="summary__grid" v-for="char in ['w', 'l']" :key="char">
						<div class="summary__item" v-for="num in 3" :key="num">
							<div class="summary__itemLabel">
								{{ char.toUpperCase() }}{{ num }}
							</div>
							<div class="summary__itemValue">
								{{ values.wind.local.suction[char][num - 1] }} kN/m2
							</div>
						</div>
					</div>
				</div>
			</template>
		</template>

		<template v-else>
			<div class="summary__section">
				<p class="summary__sectionTitle">{{ $t("Geral") }}</p>

				<div class="summary__grid">
					<div class="summary__item">
						<div class="summary__itemLabel">
							{{ $t("Pressão") }}
						</div>
						<div class="summary__itemValue">
							{{ values.wind.general.pressure.w[0] }} kN/m2
						</div>
					</div>

					<div class="summary__item">
						<div class="summary__itemLabel">
							{{ $t("Sucção") }}
						</div>
						<div class="summary__itemValue">
							{{ values.wind.general.suction.w[0] }} kN/m2
						</div>
					</div>
				</div>
			</div>

			<div class="summary__section" v-if="values.wind.local.use">
				<p class="summary__sectionTitle">{{ $t("Local") }}</p>

				<div class="summary__grid">
					<div class="summary__item">
						<div class="summary__itemLabel">
							{{ $t("Pressão") }}
						</div>
						<div class="summary__itemValue">
							{{ values.wind.local.pressure.w[0] }} kN/m2
						</div>
					</div>

					<div class="summary__item">
						<div class="summary__itemLabel">
							{{ $t("Sucção") }}
						</div>
						<div class="summary__itemValue">
							{{ values.wind.local.suction.w[0] }} kN/m2
						</div>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import emitLifecycleEvents from "@/mixins/emitLifecycleEvents";

import BBtn from "@/components/base/BBtn.vue";
import BIcon from "@/components/base/BIcon/index.vue";

export default {
	mixins: [emitLifecycleEvents],
	components: {
		BBtn,
		BIcon,
	},
	props: {
		values: {
			type: Object,
			required: true,
		},
		sectionTitleStyle: {
			type: String,
			default: "block",
		},
	},
	computed: {
		...mapState("simulator", ["simulationOptions"]),
		...mapGetters("simulator", ["getOption"]),
		deltaCfgSummaryContent() {
			const { deltas } = this.values.wind;

			return deltas
				.map((delta, idx) => {
					return `<p>Ψ${idx} - ${delta}</p>`;
				})
				.join("");
		},
	},
};
</script>

<style lang="scss"></style>
